export class Addr {
    public id: number;
    public addressLine1: string = '';
	addressLine2: string = '';
	city: string = '';
	stateOrProvinceId: number;
	countryId: number;
	zipOrPostalCode: string = '';

}
